import React from "react";
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import { Link } from "react-router-dom";
import "../Style/PrivacyPolicy.css"; // Ensure you create this CSS file

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>
        Below are the KPMG Africa privacy statements for different countries. Click on a country to view its privacy statement.
      </p>

      <div className="privacy-list">
        <ul>
          <li>
            <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer">
              Kenya
            </a>
          </li>
          <li>
            <a href="https://kpmg.com/gh/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer">
              Ghana
            </a>
          </li>
          <li>
            <a href="https://kpmg.com/ng/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer">
              Nigeria
            </a>
          </li>
          <li>
            <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/South%20Africa%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer">
              South Africa
            </a>
          </li>
          <li>
            <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Zambia%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer">
              Zambia
            </a>
          </li>
          <li>
            <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Zimbabwe%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer">
              Zimbabwe
            </a>
          </li>
          <li>
            <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Mauritius%20Privacy%20Statement.pdf" target="_blank" rel="noopener noreferrer">
              Mauritius
            </a>
          </li>
          <li>
            <a href="https://assets.kpmg.com/content/dam/kpmg/za/pdf/2024/Mozambique%20Privacy%20Statement%20-%20July%202024.pdf" target="_blank" rel="noopener noreferrer">
              Mozambique
            </a>
          </li>
          <li>
            <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer">
              Rwanda
            </a>
          </li>
          <li>
            <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer">
              Tanzania
            </a>
          </li>
          <li>
            <a href="https://kpmg.com/ke/en/home/misc/privacy.html" target="_blank" rel="noopener noreferrer">
              Uganda
            </a>
          </li>
        </ul>
      </div>

      <Link to="/" className="back-link">Back to Home</Link>
    </div>
  );
};

export default PrivacyPolicy;
